import { apiGet, apiDelete } from './client';

/** One venue on the Check ID for Teams launch list. */
export interface WaitlistEntry {
  id: string;
  email: string;
  organizationName: string | null;
  venueCount: number | null;
  region: string | null;
  country: string | null;
  source: string | null;
  note: string | null;
  wantsPreview: boolean;
  notifiedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * GET /admin/teams-waitlist — the pre-launch interest list.
 *
 * Deliberately NOT the same thing as /admin/feedback/emails, which the Emails
 * view shows: that is newsletter signups collected in the feedback table by the
 * consumer app. These are venues who asked to be told when Teams opens, and
 * mixing them would make both lists useless.
 *
 * The endpoint returns a plain array (newest first, server-capped at 1000)
 * rather than a paginated envelope — the list is small by nature and will stay
 * that way until launch, at which point it stops growing.
 */
export function listWaitlist(limit = 500): Promise<WaitlistEntry[]> {
  return apiGet<WaitlistEntry[]>('/admin/teams-waitlist', { limit });
}

/**
 * DELETE /admin/teams-waitlist/:id — prune an entry.
 *
 * For test rows, bots, typo'd addresses, and anyone who asks to come off the
 * list. The list shipped without this, which made every one of those permanent.
 */
export function removeWaitlistEntry(id: string): Promise<{ status: string; email: string }> {
  return apiDelete(`/admin/teams-waitlist/${encodeURIComponent(id)}`);
}
